export function addMeasurement(eventId, studentId, measurementId, measurementValue) {
  return {
    type: "ADD_MEASUREMENT",
    eventId,
    studentId,
    measurementId,
    measurementValue
  };
}

export function updateMeasurement(eventId, studentId, measurementId, measurementValue) {
  return {
    type: "UPDATE_MEASUREMENT",
    eventId,
    studentId,
    measurementId,
    measurementValue
  };
}



// WEBPACK FOOTER //
// ./actions/measurements.js